import { render, staticRenderFns } from "./CaddieIncomeStatus.vue?vue&type=template&id=2cdd8d8e&"
import script from "./CaddieIncomeStatus.vue?vue&type=script&lang=js&"
export * from "./CaddieIncomeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports